import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from "@angular/router";
import { Adal4Service, Adal4HTTPService } from 'adal-angular4';


@Injectable()
export class TokenService{
    constructor(private router: Router, private adalService: Adal4Service){}
    

    handleTokenExpiration() : Promise<boolean>{
        var expirationDateString = localStorage.getItem("tokenExpDate");
        var expirationTime: Date = new Date(expirationDateString);
        var now = new Date();

        //console.log("Data de agora do token service", now);

        if(now > expirationTime){     
            localStorage.setItem("SessionExpired", "true");       
            alert("Sua seção expirou. Saia e faça login novamente.");
            //this.adalService.logOut();     
            return Promise.resolve(false);                    
        }
        return Promise.resolve(true);
    }
    
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/services/token.service.ts